import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface LineChartProps {
  data: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      fill: boolean;
      borderColor: string;
      tension: number;
    }[];
  };
}

const LineChartComponent: React.FC<LineChartProps> = ({ data }) => {
  // Transform the data to match recharts format
  const chartData = data.labels.map((label, index) => {
    const dataset = data.datasets[0];
    if (!dataset) return { name: label };
    return {
      name: label,
      [dataset.label]: dataset.data[index],
    };
  });

  return (
    <div className="h-72">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={chartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          {data.datasets[0] && (
            <Line 
              type="monotone" 
              dataKey={data.datasets[0].label}
              stroke={data.datasets[0].borderColor}
              strokeWidth={2}
              activeDot={{ r: 8 }}
              dot={{ r: 4 }}
            />
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartComponent;